/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { CARD_GAP, REFETCH_CONFIGURATION } from "../../../utils/constants";
import BackButton from "../../feedBacks/BackButton";
import StatsCard from "../../Cards/statsCard";
// import GaugeChart from "../../Charts/DTStatus";
import { useFetchData } from "../../../customHooks/useGetDashboardData";
import { formatCustomDateDayMonthYear } from "../../../utils/utils";
import Loader2 from "../../feedBacks/loader2";
import { IDevice } from "../../../utils/interfaces";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { memo, useCallback, useEffect, useState } from "react";
import DeviceDetailTable from "../../Table/DeviceDetailTable";
import "../../../styles/custom-styles.css";
import { useUtils } from "../../../customHooks/useUtils";
import FinancialPerformanceChart from "../../Charts/FinancialPerformance";
import { RiBillFill } from "react-icons/ri";
import { IconWrapper } from "../../../customHooks/useIcon";
import AppModal from "../../feedBacks/AppModal";
import AppButton from "../../Inputs/AppButton";
import { enqueueSnackbar } from "notistack";
import { ButtonType, TextInputType } from "../../../enums/componentEnums";
import AppDateInput from "../../Inputs/AppDate";
import useCustomFormik from "../../../customHooks/useFormik";
import * as Yup from "yup";
import apiFetcher from "../../../utils/apiFetcher";
import { setStartDate } from "../../../store/filterSlice";
// import DailyExpectedRevenueChart from "../../Charts/ExpectedRevenueChart";
import DailyConsumptionChart from "../../Charts/DailyConsumption";
import html2canvas from "html2canvas";

function FinanceSite({
  site_id,
  from_aggregate,
}: {
  site_id: string;
  from_aggregate?: boolean;
}) {
  const language = useAppSelector((state) => state.language.language);
  const [isGenerateBillModalOpen, setIsGenerateBillModalOpen] = useState(false);
  const [isLocalLoading, setIsLocalLoading] = useState(false);
  const [isDateInitialized, setIsDateInitialized] = useState(false);
  const dispatch = useAppDispatch();

  // Initialize date first
  useEffect(() => {
    dispatch(setStartDate({ isFromFinance: true }));
    setIsDateInitialized(true);
  }, [dispatch]);

  // Get dates from store after initialization
  const startDate = useAppSelector((state) => state.filter.startDate);
  const endDate = useAppSelector((state) => state.filter.endDate);

  // Fetch operations data with React Query
  const { mapResponseToLabelValue, INSTATAENOUS_KPIS, t } = useUtils();
  const {
    data: operationsData,
    isLoading: operationsLoading,
    error: operationsError,
    refetch,
  } = useFetchData(
    ["/site", "fetchFinanceSite", site_id],
    `/finance/site/${site_id}`,
    {
      start_date: startDate,
      end_date: endDate,
    },
    // @ts-ignore
    {
      ...REFETCH_CONFIGURATION,
      enabled: isDateInitialized, // Only fetch after date is initialized
    }
  );

  // Fetch site details with React Query
  const {
    data: siteDetails,
    isLoading: siteDetailIsLoading,
    error: siteDetailError,
  } = useFetchData<IDevice>(
    ["/site", "fetchSiteDetail", site_id],
    `/device/${site_id}`,
    {},
    // @ts-ignore
    {
      refetchOnMount: true,
      refetchOnWindowFocus: true,
      enabled: !!site_id,
    }
  );

  // Fetch site details with React Query
  const { data: siteStatusData } = useFetchData<any>(
    ["/site", "fetchSiteStatus", site_id],
    `/device-status/${site_id}`,
    {},
    // @ts-ignore
    {
      ...REFETCH_CONFIGURATION,
    }
  );

  const isLoading =
    // Show loading for initial page load
    operationsLoading ||
    // Show loading when filter is applied and when actually refetching
    isLocalLoading;

  useEffect(() => {
    if (startDate && endDate && isDateInitialized) {
      setIsLocalLoading(true);

      refetch().finally(() => {
        setIsLocalLoading(false);
      });
    }
  }, [startDate, endDate, refetch, isDateInitialized]);

  // Transform operations data using React Query's data
  const transformedData = operationsData
    ? mapResponseToLabelValue(operationsData)
    : [];

  // Render stats cards
  const renderStatsCards = useCallback(
    (dataSlice: any[], noOfLoadBox: number) => {
      if (isLoading) {
        return Array.from({ length: noOfLoadBox }).map((_, index) => (
          <StatsCard
            key={`loading-${index}`}
            title=""
            value=""
            isError={false}
            isLoading={true}
          />
        ));
      }

      if (operationsError) {
        return Array.from({ length: 4 }).map((_, index) => (
          <StatsCard
            key={`error-${index}`}
            title=""
            value=""
            isError={true}
            isLoading={false}
            cardErrorStyle="!h-[50px]"
          />
        ));
      }
      const excludeCards = [t("readings.unknown")];

      return dataSlice.map(
        (data: any, index: number) =>
          !excludeCards.includes(data.label) && (
            <div key={`stat-${index}`}>
              <StatsCard
                title={data.label}
                time={
                  INSTATAENOUS_KPIS.includes(data.label)
                    ? (operationsData as any).time
                    : ""
                }
                period={
                  !INSTATAENOUS_KPIS.includes(data.label)
                    ? formatCustomDateDayMonthYear(startDate, endDate, language)
                    : ""
                }
                value={data.value as string}
                isError={false}
                isLoading={false}
                currency={(operationsData as any).currency}
              />
            </div>
          )
      );
    },
    [
      isLoading,
      operationsError,
      operationsData,
      startDate,
      endDate,
      INSTATAENOUS_KPIS,
      t,
      language,
    ]
  );
  const validationSchema = Yup.object().shape({
    startDate: Yup.date().required("Start date is required"),
    endDate: Yup.date()
      .required("End date is required")
      .min(Yup.ref("startDate"), "End date must be after start date"),
  });
  const formik = useCustomFormik({
    initialValues: {
      startDate: "",
      endDate: "",
      gateway_serials: [],
    },
    validationSchema,
   onSubmit: async (values) => {
  try {
    formik.setSubmitting(true);

    const url = `/generate-bill/${site_id}?start_date=${values.startDate}&end_date=${values.endDate}`;
    const response = await apiFetcher.post(url, {}, { responseType: "text" }); // 🔹 Expect text, not blob
    const html = response;
    if (!html || typeof html !== "string") throw new Error("No HTML received from server");

    // Create a hidden container for rendering the HTML
    const container = document.createElement("div");
    container.innerHTML = html;
    container.style.position = "absolute";
    container.style.top = "-9999px";
    container.style.left = "-9999px";
    container.style.width = "1200px"; // force a consistent width
    document.body.appendChild(container);

    // Convert the container into a canvas
    const canvas = await html2canvas(container, { scale: 2 }); // High-res
    const dataUrl = canvas.toDataURL("image/png");

    // Trigger the download
    const link = document.createElement("a");
    link.href = dataUrl;
    link.download = "bill.png";
    link.click();

    // Clean up
    document.body.removeChild(container);

    enqueueSnackbar("Bill downloaded successfully", { variant: "success" });
    formik.setSubmitting(false);
    formik.resetForm();
  setIsGenerateBillModalOpen(false);
  } catch (error) {
    console.error("Bill generation failed:", error);
    enqueueSnackbar("Error downloading bill. Please try again.", {
      variant: "error",
    });
  } finally {
    formik.setSubmitting(false);
  }
}

  });

  return (
    <div
      className="flex flex-col w-full h-full min-h-full"
      style={{ gap: CARD_GAP }}
    >
      {!from_aggregate && (
        <div className="flex w-full">
          <div className="flex gap-2 self-start justify-start items-center">
            <BackButton
              showBackText={false}
              link={`/dashboard/finance/home/${siteDetails?.company_id}`}
            />
            {siteDetailIsLoading ? (
              <Loader2 />
            ) : siteDetailError ? (
              <div className="text-red-500">
                {t("feedback_msg.error_fetching")}
              </div>
            ) : siteDetails?.asset_name ? (
              <span className="text-primary-blackMain text-xl font-bold ml-2">
                {siteDetails.asset_name}
              </span>
            ) : null}
          </div>
        </div>
      )}
      {/* site details and gauge chart */}
      <div
        className="flex flex-wrap justify-between lg:justify-start items-center w-full"
        style={{ gap: CARD_GAP }}
      >
        <div className="w-full lg:w-[450px] !lg:max-w-[450px] ">
          {
            <DeviceDetailTable
              isLoading={siteDetailIsLoading}
              data={[siteDetails as IDevice]}
              site_status={siteStatusData}
              error={siteDetailError as string}
            />
          }
        </div>
        {/* <GaugeChart site_id={site_id} /> */}
        <div
          className={`grid gap-4 flex-1 !w-full [grid-template-columns:repeat(auto-fit,minmax(250px,1fr))] ${
            window.innerWidth >= 1600 ? " " : ""
          } load-rate-custom-stat-card-style`}
          style={{
            gap: CARD_GAP,
            // gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
          }}
        >
          {renderStatsCards(transformedData.slice(0, 8), 6)}
        </div>
        {/* <KeyInsights /> */}
      </div>
      {/* first stats card */}
      <div
        className="grid w-full"
        style={{
          gap: CARD_GAP,
          gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
        }}
      >
        {renderStatsCards(transformedData.slice(8), 8)}
      </div>
      {isDateInitialized && (
        <div
          className="flex flex-wrap justify-center w-full"
          style={{ gap: CARD_GAP }}
        >
          {/* <DailyExpectedRevenueChart
            site_id={site_id}
            startDate={startDate}
            endDate={endDate}
          /> */}
          <DailyConsumptionChart
            site_id={site_id}
            startDate={startDate}
            endDate={endDate}
          />
        </div>
      )}
      <div
        className="flex flex-wrap justify-center w-full"
        style={{ gap: CARD_GAP }}
      >
        <FinancialPerformanceChart
          queryKey={["finance", "fetchFinancialPerformance", site_id]}
          route={`/finance/monthly-collection-billing/${site_id}`}
        />
      </div>
      <div
        onClick={() => setIsGenerateBillModalOpen(true)}
        className="fixed bottom-6 right-6 h-20 w-20 cursor-pointer shadow-lg hover:scale-105 transition-transform rounded-full  bg-primary-yellowMain flex items-center justify-center"
      >
        <IconWrapper icon={RiBillFill} className="text-white" size={40} />
      </div>
      <AppModal
        isOpen={isGenerateBillModalOpen}
        onClose={() => setIsGenerateBillModalOpen(false)}
      >
        <h2 className="text-lg font-bold text-primary-blackMain text-center">
          Generate Bill for {siteDetails?.asset_name}
        </h2>
        <form
          onSubmit={formik.handleSubmit}
          className="flex flex-col w-full space-y-4 gap-6"
        >
          <div className="w-full flex  gap-6 mt-6">
            <AppDateInput
              topLabel={t("filter.start_date")}
              name="startDate"
              value={formik.values.startDate}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              disabled={formik.isSubmitting}
              error={formik.getFieldError("startDate") as string}
              type={TextInputType.DATE}
              className={"!text-md !border-primary-border"}
            />
            <AppDateInput
              name="endDate"
              topLabel={t("filter.end_date")}
              value={formik.values.endDate}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              disabled={formik.isSubmitting}
              error={formik.getFieldError("endDate") as string}
              type={TextInputType.DATE}
              className={"!text-md !border-primary-border"}
            />
          </div>
        </form>

        <div className="flex gap-4 items-center justify-center p-4 mt-4 w-full *:sm:w-1/2">
          <AppButton
            text={formik.isSubmitting ? "" : "Generate Bill"}
            loader={{
              loading: formik.isSubmitting,
              height: 4,
              width: 4,
            }}
            type={ButtonType.PRIMARY}
            handleClick={formik.handleSubmit}
            disabled={formik.isSubmitting}
          />
          <AppButton
            text="Cancel"
            type={ButtonType.SECONDARY}
            handleClick={() => setIsGenerateBillModalOpen(false)}
          />
        </div>
      </AppModal>
    </div>
  );
}

export default memo(FinanceSite);
